// DepthInfo 主要資料key值
export enum filterTypesKey {
    TravelType = 'TravelType', // 旅遊型態
    DepartureList = 'DepartureList', // 出發地
    WeekDays = 'WeekDays', // 出發星期
    DayList = 'DayList', // 旅遊天數
    AirlineList = 'AirlineList', // 航空公司
    PriceRange = 'PriceRange', // 預算
    CategoryList = 'CategoryList', // 標籤模組資料
}

// 切換列表顯示使用參數
export enum e_switchListsbBy {
    List = 'List', // 切換列表顯示
    Cards = 'Cards', // 切換個團顯示
}

// 判斷價錢為最小獲最大
export enum priceType {
    min = 'min',
    max = 'max',
}

export interface I_RootState {
    FilterItems?: I_FilterItem[];
    TempFilterItems?: I_FilterItem[]; // 用共暫存filterItems 給M版側開回覆上階段state用
    SortListBy?: number;
    SwitchListBy?: string;
    TagFiltersShow?: string[];
    TempTagFiltersShow?: string[];
    DepthInfo?: I_DepthInfo;
    GroupListInfo: {
        data: I_GroupListInfo | undefined;
        isLoading: boolean;
    };
    GroupListInfoM: {
        data: I_GroupListInfo | undefined;
        isLoading: boolean;
        PageSize: number;
    };
    SingleGroupListInfo: {
        data: I_SingleGroupListInfo | undefined;
        isLoading: boolean;
    };
    callJson?: I_CallJson;

    SingleGroupListInfoM: {
        data: I_GroupListInfo | undefined;
        isLoading: boolean;
        PageSize: number;
    };
    PackageInfo?: I_PackageInfo;
    ChangeItem?: boolean;
    Tags?: string;
    Trigger?: string;
}
export interface I_FilterItem {
    filterBy: string; // 標籤來源是從左側篩選區塊還是上方標籤區塊
    text: string;
    value: number | string; //如果是標籤來的會是 TripTypeCode_GroupNo_TagNo
    subValue: string; // 特殊情況用於判斷字串 如: 價錢的 min or max
}

// search/DepthInfoJson (取得進階搜尋項目)
export interface I_DepthInfo {
    WeekDays?: I_WeekDay[]; // 出發星期
    DayList?: I_Day[]; // 旅遊天數
    PriceRange?: I_PriceRange; // 價格區間
    AirlinesList?: I_AirLine[]; // 航空公司
    TripTypeList?: I_TripType[]; // 標準團名等級
    CategoryList?: I_Category[]; // 標準團名有的旅遊型態
    DepartureList?: I_Departure[]; // 出發地清單
}

export interface I_WeekDay {
    Value: number; // 星期
    Text: string; // 星期(中文)
}

export interface I_Day {
    Value: number; // 天數
    Text: string; // 天數(中文)
}

export interface I_PriceRange {
    PriceStart: number; // 售價最小值(起)
    PriceEnd: number; // 售價最大值(迄)
}

export interface I_AirLine {
    AirlineName: string; // 航空公司名稱
    AirlineID: string; // 航空公司代碼
}

export interface I_TripType {
    TypeName: string; // 內容
    TypeCode: string; // 代碼
}

export interface I_Category {
    CategoryName: string; // 標籤類別名稱
    CategoryCode: string; // 標籤類別代碼
    CategorySort: number; // 標籤類別排序
    TypeList: I_Type[]; // 標籤類型清單
}

export interface I_Type {
    TypeName: string; // 標籤類型名稱
    TypeCode: string; // 標籤類型代碼
    TypeSort: string; // 標籤類型排序
    TripTypeName: string; // 旅遊類型名稱
    TripTypeCode: string; // 旅遊類型代碼
    TripTypeSort: number; // 旅遊類型排序
    GroupList: I_Group[]; // 群組清單
}

export interface I_Group {
    GroupName: string; // 群組名稱
    GroupNo: string; // 群組代碼
    GroupSort: string; // 群組排序
    TagList: I_Tag[]; // 標籤清單
}

export interface I_Tag {
    TagName: string; // 標籤名稱
    TagNo: string; // 標籤代碼
    TagSort: number; // 標籤排序
    IsDelete: boolean; // 標籤清單
}

export interface I_Departure {
    CityCode: string; // 城市代碼
    CityName: string; // 城市名稱
}

// search/GroupListInfoJson (取得熱銷與一般行程)
export interface I_GroupListInfo {
    TotalCount: number; // 總筆數
    TotalPage: number; // 總頁數
    CurrentPage: number; // 目前頁數
    Count: number; // 目前筆數
    NormGroupList: I_NormGroup[];
}

export interface I_NormGroup {
    Index: number; // 排序,0為熱銷
    NormGroupID: string; // 標準團名ID
    TourName: string; // 行程名稱
    TourDays: number; // 行程天數
    Img: string; // 標準團名小圖
    ImgM: string; // 標準團名中圖
    TravelType: string; // 旅遊型態(1:團體、2:團體自由行)
    GroupStraightPrice: string; // 售價(原_GroupListItem.cshtml判斷顯示售價邏輯)
    GroupIndustryPrice: string; // 單團大人最低批售價
    GroupIsVip: boolean; // 是否有會員限購
    GroupVipOrigPrice: string; // 原價(原_GroupListItem.cshtml判斷顯示售價邏輯)
    Status: number; // 產品開團狀態
    ThemeID?: string[]; // 主題編號
    GroupList: I_NormGroupGroup[]; // 單團清單
    IsCruise: boolean; // 是否為郵輪團
    TourBu: string; // 聯營商品公司名稱
    LevelID: string; // 標準團名等級ID
    FeatureSrc: string; // 特色來源
    ImgNo: string; // 圖片代碼
    TagList: I_NormGroupTag[]; //標籤清單
    TripTypeList: I_TripTypeList[]; // 旅遊型態 EXAPI PD23,25增加回傳此標準團的旅遊型態
    StartFromCityList: I_StartFromCity[]; // 出發國城 EXAPI PD23,25 增加回傳此標準團名下前3團不重複的出發國城
    StationAddress: string[]; // 集合地點 EXAPI PD23,25 增加回傳此標準團名下前3團不重複的集合地點,INAPI有
}

export interface I_NormGroupGroup {
    GroupID: string; // 團號(後面加「-開團公司」)
    GoDate: string; // 出發日期
    Status: string; // ensure,selling,full 成團狀態
    StatusText: string; // 成團狀態顯示文字
    StraightLowestPrice: string; // 大人最低直售價
    IndustryLowestPrice: string; // 大人最低批售價
    IsVip: boolean; // 是否有會員限購價
    VipOrigPrice: string; // 會員限購價最低價
}

export interface I_NormGroupTag {
    TagName: string; // 標籤名稱
    TagSort: number; // 標籤順序
}

export interface I_TripTypeList {
    TypeName: string; // 旅遊型態名稱
    TypeCode: string; // 旅遊型態代碼
}

export interface I_StartFromCity {
    CityName: string; // 城市名稱
    CityCode: string; // 城市代碼
}

// search/SingleGroupListInfoJson (取得切換個團列表)
export interface I_SingleGroupListInfo {
    TotalCount: number; // 總筆數
    TotalPage: number; // 總頁數
    CurrentPage: number; // 目前頁數
    Count: number; // 目前筆數
    SingleGroupList: I_SingleGroup[];
}

export interface I_SingleGroup {
    DirectionList: Array<I_DirectionList>;
    NormGroupID: string; // 標準團名ID
    TourName: string; // 行程名稱
    TourDays: number; // 行程天數
    TravelType: string; // 旅遊型態(1:團體、2:團體自由行)
    GroupID: string; // 團號(後面加「-開團公司」)
    GoDate: string; // 出發日期
    Status: number; // 產品開團狀態
    StatusUrl: string; // 連結
    StatusText: string;
    TourBu: string; // 聯營商品公司名稱
    TotalSeats: number; // 團位數量
    QuotaSeats: number; // 可賣數量
    IsEnsureGroup: boolean; // 是否成團
    ThemeID?: string[]; // 主題編號
    StraightLowestPrice: string; // 單團大人最低直售價
    IndustryLowestPrice: string; // 單團大人最低批售價
    IsVip: boolean; // 是否有會員限購
    VipOrigPrice: string; // 原價
    IsCruise: boolean; // 是否為郵輪團
    HasFlight: boolean; // 是否有航班
    LevelID: string; // 標準團名等級ID
    FeatureSrc: string; // 特色來源
    TagList: I_NormGroupTag[]; //標籤清單
    TripTypeList: I_TripTypeList[]; // 旅遊型態 EXAPI PD23,25增加回傳此標準團的旅遊型態
    TelType: number; // 類型
    StartFromCityList?: I_StartFromCity[];
}

// detail/PackageInfoJson (本日其他出發團與航班資訊)
export type I_PackageInfo = Array<I_GroupList>;

export interface I_GroupList {
    GroupID: string; // 團號-團號公司
    IsEnsureGroup: boolean; // 是否為保證出團
    TotalSeats: number; // 總團位數
    QuotaSeats: number; // 可賣位數
    StraightLowestPrice: number; // 大人最低值售價
    IsVip: boolean; // 是否有會員限購價
    VipOrigPrice: number; // 會員限購價最低價
    Status: number; // 產品開發狀態： 1:報名, 2:候補, 3:額滿, 4:請洽專員, 5:關團(包含結團、鎖團、已截止), 6:近期上架
    StatusName: string; // 狀態名稱
    StatusClass: string; // 狀態等級
    ArriveTaiwanDate: string; // 抵達台灣時間
    DirectionList: Array<I_DirectionList>; // 航班資訊
}

export interface I_DirectionList {
    id: string; // 航班方向: 1:去程, 9:回程, O:中段, X:湊票不含此段
    Name: string; // 航班方向名稱: 1:去程, 9:回程, O:中段, X:湊票不含此段
    FlightList: Array<I_FlightList>;
}

export interface I_FlightList {
    DepartureDate: string; // 出發日期
    DepartTime: string; // 出發時間
    ArriveDate: string; // 抵達日期
    ArriveTime: string; // 抵達時間
    DepartureAirport: string; // 起飛機場
    ArriveAirport: string; // 抵達機場
    Airline: string; // 航空公司
    FlightNo: string; // 航班或班次編號
    FlightTime: string; // 飛行時間
}

export interface I_CallJson {
    BuName: string; // 聯營商品公司名稱
    Data:
        | {
              Staff: string; // 業務人員
              Phone: string; // 電話
          }[]
        | null;
}
